import logoDarkUrl from "../assets/logo-dark.svg";
import logoLightUrl from "../assets/logo-light.svg";

const setupFavicons = () => {
  const head = document.head;

  // Add favicon for light mode
  const faviconLight = document.createElement("link");
  faviconLight.rel = "icon";
  faviconLight.href = logoLightUrl;
  faviconLight.media = "(prefers-color-scheme: light)";
  head.appendChild(faviconLight);

  // Add favicon for dark mode
  const faviconDark = document.createElement("link");
  faviconDark.rel = "icon";
  faviconDark.href = logoDarkUrl;
  faviconDark.media = "(prefers-color-scheme: dark)";
  head.appendChild(faviconDark);

  // Add apple-touch-icon for light mode
  const appleTouchLight = document.createElement("link");
  appleTouchLight.rel = "apple-touch-icon";
  appleTouchLight.href = logoLightUrl;
  appleTouchLight.media = "(prefers-color-scheme: light)";
  head.appendChild(appleTouchLight);

  // Add apple-touch-icon for dark mode
  const appleTouchDark = document.createElement("link");
  appleTouchDark.rel = "apple-touch-icon";
  appleTouchDark.href = logoDarkUrl;
  appleTouchDark.media = "(prefers-color-scheme: dark)";
  head.appendChild(appleTouchDark);
};

// Run the setup when the module loads
setupFavicons();
